import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { stylesContainer } from '../../../styles/selectCardAnonimous';
import { selectPaymentServiceConfArrayServices } from '../../../store/selectors/paymentsSelectors';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';
import { useClaropaySdk } from '../../../services/sdk/SDKServiceWeb.tsx';
import { deleteAllCards, executeTaggeo, setAddCardFormData, setCvvForAnonimous, setPaymentMethod } from '../../../store/actions';
import dummyInputs from '../../../store/sagas/dummyAddCardForm.json';
import { getMessage } from '../../organisms/utils.js';

const AddCardForm = (props) => {

    const [inputs, setInputs] = React.useState([]);
    const [focused, setFocused] = React.useState("");
    const [isActiveContinueBtn, setIsActiveContinueBtn] = React.useState(false);
    const [isLoadingContinue, setIsLoadingContinue] = React.useState(false);
    const [showDegrade, setShowDegrade] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");

    const styles = stylesContainer.addCard;

    const handleOnfocus = (input) => {
        setFocused(input.id);
        let inputsFilter = props.addCardFormData.inputsError 
            ? props.addCardFormData.inputsError.filter(e => (e.id !== input.id)) 
            : [];
        props.setAddCardFormData({ ...props.addCardFormData, inputsError: inputsFilter });
    }

    const handleOnBlur = (e, input) => {
        setFocused("");

        const { value } = e.target;

        let inputsFilter = props.addCardFormData.inputsError 
            ? props.addCardFormData.inputsError.filter(e => (e.id !== input.id)) 
            : [];

        if (input.errorEmpty && value.length === 0) {
            inputsFilter = [
                ...inputsFilter,
                {
                    id: input.id,
                    error: "errorEmpty"
                }
            ]
        }

        if (
            input.errorIncomplete &&
            value.length > 0 &&
            value.length < input.maxLength
        ) {
            inputsFilter = [
                ...inputsFilter,
                {
                    id: input.id,
                    error: "errorIncomplete"
                }
            ]
        }

        if (input.errorInvalid) {
            if (
                input.id === "expiration" &&
                value.length === input.maxLength
            ) {
                let curDate = new Date();

                let curMonth = curDate.getMonth();
                    curMonth = parseInt(curMonth) + 1;

                let curYear = curDate.getFullYear().toString().slice(-2);
                    curYear = parseInt(curYear);

                let inputMonth = value.slice(0,2);
                    inputMonth = parseInt(inputMonth);

                let inputYear = value.slice(-2);
                    inputYear = parseInt(inputYear);

                if (
                    curYear > inputYear || 
                    (curYear === inputYear && curMonth > inputMonth) ||
                    inputMonth < 1 || 
                    inputMonth > 12
                ) {
                    inputsFilter = [
                        ...inputsFilter,
                        {
                            id: input.id,
                            error: "errorInvalid"
                        }
                    ]
                }                
            }

            if (
                input.id === "email" &&
                value.length > 0
            ) {
                const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                if (!regex.test(value)) {
                    inputsFilter = [
                        ...inputsFilter,
                        {
                            id: input.id,
                            error: "errorInvalid"
                        }
                    ]
                }
            }
        }

        if (!props.addCardFormData.showError) {
            props.setAddCardFormData({ ...props.addCardFormData, inputsError: inputsFilter });
        }        
    }

    const handleOnInput = (e, input) => {

        const { id } = input;
        let value = e.target.value;

        if (id === "card-number") {
            value = e.target.value.replace(/\D/g, '');

            let creditCardNumberValue = "";
            let typeCard = "";

            if (value.length <= 16) {
                creditCardNumberValue = value.replace(/(\d{4})(?=\d)/g, '$1 ');
            }

            const visaRegex = /^4[0-9]{15}$/;
            const mastercardRegex = /^5[1-5][0-9]{14}$/;

            if (visaRegex.test(value)) {
                typeCard = "visa";
            }
            else if (mastercardRegex.test(value)) {
                typeCard = "mastercard";
            }
            else {
                typeCard = "";
            }

            props.setAddCardFormData({ ...props.addCardFormData, creditCardNumberValue, typeCard, showError: false })
        }

        if (id === "name") {
            if (value.length <= input.maxLength) {
                const formattedValue = value.replace(/[^a-zA-ZñÑáéíóúüÁÉÍÓÚÜ\s]/g, '');
                props.setAddCardFormData({ ...props.addCardFormData, userNameValue: formattedValue, showError: false });
            }
        }

        if (id === "expiration") {
            value = value.slice(0, 5);

            const numericValue = value.replace(/\D/g, '');
            let formattedValue = numericValue;

            if (numericValue.length > 2 && numericValue.indexOf('/') === -1) {
                formattedValue = `${numericValue.slice(0, 2)}/${numericValue.slice(2, 4)}`;
            }

            props.setAddCardFormData({ ...props.addCardFormData, expirationCardValue: formattedValue, showError: false });
        }

        if (id === "cvv") {
            const numericValue = value.replace(/\D/g, '');
            if (numericValue.length <= input.maxLength) {
                props.setAddCardFormData({ ...props.addCardFormData, cvvValue: numericValue, showError: false });
            }
        }

        if (id === "email") {
            if (value.length <= input.maxLength) {
                props.setAddCardFormData({ ...props.addCardFormData, emailValue: value, showError: false });
            }
        }
    }

    const handleOnClickContinueBtn = (e) => {
        const { expirationCardValue, userNameValue, creditCardNumberValue, isTemporalClaroId } = props.addCardFormData;

        if (!isLoadingContinue) {
            let typeCard = "";

            if (props.addCardFormData.typeCard === "visa") {
                typeCard = "Visa";
            }

            if (props.addCardFormData.typeCard === "mastercard") {
                typeCard = "MasterCard";
            }

            props.executeTaggeo({
                step: "Formulario de pago",
                brand: typeCard,
                action: "Click modal Continuar",
                modal_id: "Ingresa una tarjeta"
            });

            //

            const expirationCardValueSplit = expirationCardValue.split("/");
            const cardData = {
                name: userNameValue,
                cvv2: "123",
                yearExpiration: expirationCardValueSplit[1],
                monthExpiration: expirationCardValueSplit[0],
                pan: creditCardNumberValue.replaceAll(" ", "")
            }

            // Save card flux
            const tokenizeCard = async () => {
                try {
                    // Is loading true
                    setIsLoadingContinue(true);

                    // Get tokens from web sdk
                    const tokenFull = await ClaroSDKService.getFullToken();

                    // Delete cards
                    await props.deleteAllCards(tokenFull);

                    // Call appsync from web sdk
                    await useClaropaySdk().appSync(
                        process.env.REACT_APP_APPSYNC_COUNTRY_ID,
                        process.env.REACT_APP_APPSYNC_BUNDLE_ID,
                        process.env.REACT_APP_APPSYNC_BUNDLE_VERSION,
                        process.env.REACT_APP_APPSYNC_BANK_ID,
                    );

                    // Set token
                    await useClaropaySdk().setToken(isTemporalClaroId, tokenFull);

                    // Save card
                    let saveCard = await useClaropaySdk().saveCard(cardData);
                        saveCard = JSON.parse(saveCard);
                    
                    const { success } = saveCard;

                    if (!success) {
                        handleSaveCardError();
                    } else {
                        // Set cvv for anonimous
                        props.setCvvForAnonimous(props.addCardFormData.cvvValue);

                        // Set value to show snackbar or go towards confirmation ticket 
                        props.handleValidateIfSentToTicket(true);

                        // Hide error and set default payment method 
                        props.setAddCardFormData({ ...props.addCardFormData, showError: false, handleSetDefaultPaymentMethod: true });
                        
                        // Is loading false
                        setIsLoadingContinue(false);

                        // Close modal
                        props.handleCloseSelectCardAnonimous();

                        // Launch search card
                        props.setPaymentMethod({ cardId: saveCard.data.cardId });

                        // Set value tu show loader 
                        props.handleShowLoaderWaitSubmit(true);
                    }
                } catch (error) {
                    handleSaveCardError();
                }

            }

            // Launch save card flux
            tokenizeCard();
        }
    }

    const handleSaveCardError = () => {
        setIsActiveContinueBtn(false);
        setIsLoadingContinue(false);
        props.setAddCardFormData({ ...props.addCardFormData, showError: true });
    }

    React.useEffect(() => {
        const formElements = dummyInputs.elementsAddCard;

        if (formElements) {
            setInputs(formElements);
        }
    }, [props.configServices]);

    React.useEffect(() => {

        const { 
            inputsError, 
            creditCardNumberValue, 
            userNameValue, 
            expirationCardValue,
            showError,
            cvvValue
        } = props.addCardFormData;

        if (inputsError && creditCardNumberValue && userNameValue && expirationCardValue && cvvValue) {
            setIsActiveContinueBtn(
                !showError &&
                inputsError.length === 0 &&
                creditCardNumberValue.length === 19 &&
                userNameValue.length > 0 &&
                expirationCardValue.length === 5 &&
                cvvValue.length === 3
                    ? true
                    : false
            );
        }
    }, [props.addCardFormData]);

    React.useEffect(() => {
        const CP = getMessage(props.messages, "CP0023", "MiniAppTelcel");
        if (CP && CP.data) {
            const { data } = CP;
            setErrorText(data.message);
        }
    }, [props.messages])

    React.useEffect(() => {
        const cardContainer = document.querySelector("#cardContainer");

        cardContainer.addEventListener("scroll", () => {
            setShowDegrade(cardContainer.scrollTop > 30 ? true : false)
        })
    }, []);

    React.useEffect(() => {
        if (props.addCardFormData.isOpenAddCardForm) {
            props.executeTaggeo({
                step: "Formulario de pago",
                action: "View modal",
                modal_id: "Ingresa una tarjeta"
            });
        }
    }, [props.isOpen])

    return (
        <div style={{ overflowY: 'scroll', height: "100%", position: "fixed", width: "calc(100% - 32px)" }} id='cardContainer'>
            {/* Degrade */}
            {
                showDegrade &&
                <div style={{
                    position: "fixed",
                    width: "inherit",
                    height: "45px",
                    background: "linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.7), rgba(255,255,255,0.4), rgba(255,255,255,0)"
                }} />
            }

            {/* Header logos */}
            <div style={styles.headerContainer}>
                <img src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}logo_mastercard_y_visa.png` } style={styles.headerLogos} />
            </div>

            {/* Header title */}
            <p style={styles.title}>
                <span style={styles.titleLight}>
                    Ingresa una tarjeta
                </span>
                &nbsp;
                <span style={styles.titleDark}>
                    de crédito o débito
                </span>
                &nbsp;
                <span style={styles.titleLight}>
                    para hacer tus pagos
                </span>
            </p>

            {/* Header subtitle */}
            <p style={styles.subtitle}>
                <span style={styles.subtitleLight}>
                    Por el momento sólo aceptamos
                </span>
                &nbsp;
                <span style={styles.subtitleDark}>
                    VISA y MasterCard
                </span>
            </p>

            {/* Inputs */}
            {
                inputs.map((input, index) => {
                    /* Style validation for empty or error value and type card */
                    let styleWrapper = styles.wrapper;
                    let styleLabel = styles.inputLabel;
                    let styleInput = styles.inputControl;
                    let errorMessage = undefined;

                    if (focused === input.id) {
                        styleLabel = styles.inputLabelFocused;
                        styleInput = styles.inputControlFocused;
                    }

                    if (input.infoMessage) {
                        styleInput = {
                            ...styleInput,
                            margin: "0px 0px 8px 0px"
                        }
                    }

                    const hasError = props.addCardFormData.inputsError 
                        ? props.addCardFormData.inputsError.find(i => i.id === input.id)
                        : undefined;

                        if (hasError) {
                        switch (hasError.error) {
                            case "errorEmpty":
                                styleLabel = styles.inputLabelError;
                                styleInput = styles.inputControlError;
                                errorMessage = input.errorEmpty
                                break;

                            case "errorIncomplete":
                                styleLabel = styles.inputLabelError;
                                styleInput = styles.inputControlError;
                                errorMessage = input.errorIncomplete
                                break;

                            case "errorInvalid":
                                styleLabel = styles.inputLabelError;
                                styleInput = styles.inputControlError;
                                errorMessage = input.errorInvalid
                                break;

                            default:
                                break;
                        }
                    }

                    if (input.id === "card-number") {
                        if (props.addCardFormData.typeCard === "visa") {
                            styleInput = {
                                ...styleInput,
                                backgroundImage: "url(/images/Visa-Logo.png)",
                                backgroundPosition: "right 16px top",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "auto 18px"
                            }
                        }
                        else if (props.addCardFormData.typeCard === "mastercard") {
                            styleInput = {
                                ...styleInput,
                                backgroundImage: "url(/images/mastercard-logo-logok-15.png)",
                                backgroundPosition: "right 16px top",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "auto 18px"
                            }
                        }
                    }

                    if (input.id === "cvv") {
                        styleWrapper = {
                            ...styleWrapper,
                            backgroundImage: `url(${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_src_ct_card_form_cvv.png)`,
                            backgroundPosition: "right 2px top 15px",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "auto 31.28px",
                        }
                    }

                    /* Set value */
                    let inputValue = "";

                    if (input.id === "card-number") {
                        inputValue = props.addCardFormData.creditCardNumberValue
                    }

                    if (input.id === "name") {
                        inputValue = props.addCardFormData.userNameValue
                    }

                    if (input.id === "expiration") {
                        inputValue = props.addCardFormData.expirationCardValue
                    }

                    if (input.id === "cvv") {
                        inputValue = props.addCardFormData.cvvValue
                    }

                    if (input.id === "email") {
                        inputValue = props.addCardFormData.emailValue
                    }

                    return (
                        <div key={index} style={styleWrapper}>
                            <p style={styleLabel}>
                                {input.label}
                            </p>
                            <input
                                style={styleInput}
                                type='text'
                                inputMode={input.inputMode ? input.inputMode : "text"}
                                placeholder={input.placeholder}
                                onFocus={() => handleOnfocus(input)}
                                onBlur={(e) => handleOnBlur(e, input)}
                                onChange={(e) => handleOnInput(e, input)}
                                maxLength={input.maxLength}
                                value={inputValue} />
                            
                            {
                                input.infoMessage &&
                                <p style={styles.infoMessage}>
                                    {input.infoMessage}
                                </p>
                            }
                            
                            {
                                errorMessage &&
                                <p style={styles.errorMessage}>
                                    {errorMessage}
                                </p>
                            }
                        </div>
                    )
                })
            }

            {/* Error wording */}
            {
                props.addCardFormData.showError &&
                <div style={ styles.errorWordingWrap }>
                    <div style={ styles.errorWordingLeft } />
                    <div style={ styles.errorWordingRight }>
                        <span dangerouslySetInnerHTML={{ __html: errorText }} />
                    </div>                    
                </div>
            }

            {/* Continue Button */}
            <button
                disabled={!isActiveContinueBtn}
                style={isActiveContinueBtn ? (isLoadingContinue ? styles.continueButtonActiveLoading : styles.continueButtonActive) : styles.continueButtonInactive}
                onClick={(e) => handleOnClickContinueBtn(e)}>
                {
                    !isLoadingContinue
                        ?
                        <>
                            Continuar
                        </>
                        :
                        <img src='/images/white-loading.gif' height={25} />
                }
            </button>

            {/* Space under button */}
            <br />
            <br />
            <br />
            <br />
            &nbsp;
        </div>
    )

}

const mapStateToProps = (state) => {
    const { payments } = state;
    const configServices = selectPaymentServiceConfArrayServices(payments);
    const isTemporalClaroId = payments.isTemporalClaroId;
    const messages = payments.messages;
    const addCardFormData = payments.addCardFormData;

    return {
        configServices,
        isTemporalClaroId,
        messages,
        addCardFormData
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setPaymentMethod,
            setAddCardFormData,
            executeTaggeo,
            deleteAllCards,
            setCvvForAnonimous
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCardForm)